import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Phone-only App-Topbar für die statischen Info-Seiten (Über uns, Impressum, Datenschutz,
 * Für Partner): runder Zurück-Button + Mono-Label, gleiches Muster wie EventDetail.
 * Auf dem Desktop unsichtbar — dort übernimmt der PublicHeader.
 */
const StaticPageTopbar: React.FC<{ label: string }> = ({ label }) => {
  const navigate = useNavigate();
  // Zurueck per History; bei Deeplink ohne In-App-Verlauf auf die Startseite fallen lassen.
  const goBack = () => {
    if ((window.history.state?.idx ?? 0) > 0) navigate(-1);
    else navigate('/');
  };

  return (
    <div className="app-topbar hide-desktop">
      <button
        onClick={goBack}
        aria-label="Zurück"
        style={{
          width: 44, height: 44, borderRadius: '50%', background: '#fff', border: '1px solid #E5E1E1',
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, lineHeight: 1,
          color: '#2C2C2C', cursor: 'pointer',
        }}
      >
        ‹
      </button>
      <span style={{ fontFamily: "'Space Mono',monospace", fontSize: 12, letterSpacing: '0.12em', color: '#9A9494' }}>
        {label}
      </span>
      <span style={{ width: 44 }} />
    </div>
  );
};

export default StaticPageTopbar;
